import type { ComponentProps, ReactNode } from 'react'
import { cn, cva } from '../lib/cva'
import { Button } from './Button'
import { Text } from './Text'

export interface ActionCardProps {
	title: string
	children?: string | ReactNode
	variant?: ComponentProps<typeof Button>['variant']
	button: ComponentProps<typeof Button>
}

const containerVariants = cva('flex w-full text-start justify-between p-6 gap-x-3 rounded-sm border border-error-200', {
	variants: {
		variant: {
			primary: 'border-primary-100',
			destructive: 'border-error-200',
			'outline-destructive': 'border-error-200',
			secondary: 'border-primary-100',
			tertiary: 'border-primary-100',
		},
	},
	defaultVariants: {
		variant: 'destructive',
	},
})

export const ActionCard = ({ children, title, variant = 'destructive', button }: ActionCardProps) => {
	return (
		<div className={cn('w-full')}>
			<div className={containerVariants({ variant })}>
				<div>
					<Text variant='medium' weight='semibold'>
						{title}
					</Text>
					{children && (
						<Text variant='xsmall' className='mt-2'>
							{children}
						</Text>
					)}
				</div>
				<Button variant={variant} {...button} type='button' className={cn(button?.className, 'self-center')} />
			</div>
		</div>
	)
}
